<template>
    <div style="height: 100%; overflow: auto">
        <b-card class="sa-card" header="Dati soggetto" header-tag="header">
            <b-row>
                <b-col cols="12" md="6">
                    <label class="sa-label-data">Ragione soggetto</label>
                    <span> {{ jsonData.ragioneSoggetto }}</span>
                </b-col>

                <b-col cols="12" md="3">
                    <label class="sa-label-data">Codice soggetto</label>
                    <span> {{ jsonData.codiceSoggetto }}</span>
                </b-col>

                <b-col cols="12" md="3">
                    <label class="sa-label-data">Identificativo soggetto</label>
                    <span> {{ jsonData.identificativoSoggetto }}</span>
                </b-col>

                <b-col cols="12" md="4">
                    <label class="sa-label-data">Nome</label>
                    <span> {{ jsonData.nome }}</span>
                </b-col>

                <b-col cols="12" md="4">
                    <label class="sa-label-data">Cognome</label>
                    <span> {{ jsonData.cognome }}</span>
                </b-col>

                <b-col cols="12" md="4">
                    <label class="sa-label-data">Sesso</label>
                    <span> {{ jsonData.sesso }}</span>
                </b-col>

                <b-col cols="12" md="4">
                    <label class="sa-label-data">Data nascita</label>
                    <span>{{ formatDate(jsonData.dataNascita) }}</span>
                </b-col>
                <b-col cols="12" md="4">
                    <label class="sa-label-data">Regione nascita </label>
                    <span>{{ jsonData.regioneNascita }}</span>
                </b-col>
                <b-col cols="12" md="4">
                    <label class="sa-label-data">Provincia nascita </label>
                    <span>{{ jsonData.provinciaNascita }}</span>
                </b-col>

                <b-col cols="12" md="6">
                    <label class="sa-label-data">Comune nascita </label>
                    <span>{{ jsonData.comuneNascitaNome }}</span>
                </b-col>

                <b-col cols="12" md="6">
                    <label class="sa-label-data">Nazione soggetto</label>
                    <span>{{ jsonData.nazioneSoggetto }}</span>
                </b-col>
            </b-row>
        </b-card>

        <b-card class="sa-card" header="Contatti" header-tag="header">
            <b-row>
                <b-col cols="12" md="4">
                    <label class="sa-label-data">Telefono</label>
                    <span> {{ jsonData.telefono }}</span>
                </b-col>

                <b-col cols="12" md="4">
                    <label class="sa-label-data">Email</label>
                    <span> {{ jsonData.email }}</span>
                </b-col>

                <b-col cols="12" md="4">
                    <label class="sa-label-data">PEC</label>
                    <span> {{ jsonData.pec }}</span>
                </b-col>
            </b-row>
        </b-card>

        <b-card class="sa-card" header="Indirizzi" header-tag="header">
            <b-row>
                <b-col cols="12" md="6">
                    <label class="sa-label-data">Indirizzo soggetto</label>
                    <span>{{ jsonData.indirizzoSoggetto }}</span>
                </b-col>

                <b-col cols="12" md="3">
                    <label class="sa-label-data">Regione soggetto</label>
                    <span>{{ jsonData.regioneSoggetto }}</span>
                </b-col>

                <b-col cols="12" md="3">
                    <label class="sa-label-data">Provincia soggetto</label>
                    <span>{{ jsonData.provinciaSoggetto }}</span>
                </b-col>

                <b-col cols="12" md="3">
                    <label class="sa-label-data">Località soggetto</label>
                    <span>{{ jsonData.comuneSoggettoNome }}</span>
                </b-col>

                <b-col cols="12" md="3">
                    <label class="sa-label-data">CAP soggetto</label>
                    <span>{{ jsonData.capSoggetto }}</span>
                </b-col>

                <b-col cols="12" md="3">
                    <label class="sa-label-data">Codice destinatario</label>
                    <span>{{ jsonData.codiceDestinatario }}</span>
                </b-col>

                <b-col cols="12" md="3">
                    <label class="sa-label-data">Codice IVA</label>
                    <span>{{ jsonData.codiceIva }}</span>
                </b-col>

                <b-col cols="12" md="6">
                    <label class="sa-label-data">P.IVA soggetto</label>
                    <span>{{ jsonData.pivaSoggetto }}</span>
                </b-col>

                <b-col cols="12" md="6">
                    <label class="sa-label-data">Indirizzo domicilio</label>
                    <span>{{ jsonData.indirizzoDomicilio }}</span>
                </b-col>

                <b-col cols="12" md="3">
                    <label class="sa-label-data">Regione domicilio</label>
                    <span>{{ jsonData.regioneDomicilio }}</span>
                </b-col>

                <b-col cols="12" md="3">
                    <label class="sa-label-data">Provincia domicilio</label>
                    <span>{{ jsonData.provinciaDomicilio }}</span>
                </b-col>

                <b-col cols="12" md="3">
                    <label class="sa-label-data">Comune domicilio</label>
                    <span>{{ jsonData.comuneDomicilioNome }}</span>
                </b-col>

                <b-col cols="12" md="3">
                    <label class="sa-label-data">CAP domicilio</label>
                    <span>{{ jsonData.capDomicilio }}</span>
                </b-col>

                <b-col cols="12" md="3">
                    <label class="sa-label-data">Regione residenza</label>
                    <span>{{ jsonData.regioneResidenza }}</span>
                </b-col>

                <b-col cols="12" md="3">
                    <label class="sa-label-data">Provincia residenza</label>
                    <span>{{ jsonData.provinciaResidenza }}</span>
                </b-col>

                <b-col cols="12" md="3">
                    <label class="sa-label-data">Comune residenza</label>
                    <span>{{ jsonData.comuneResidenzaNome }}</span>
                </b-col>

                <b-col cols="12" md="3">
                    <label class="sa-label-data">CAP residenza</label>
                    <span>{{ jsonData.capResidenza }}</span>
                </b-col>
            </b-row>
        </b-card>

        <b-card class="sa-card" header="Dati commerciali/contabili" header-tag="header">
            <b-row>
                <b-col cols="12" md="6">
                    <label class="sa-label-data">Codice azienda</label>
                    <span>{{ jsonData.codiceAzienda }}</span>
                </b-col>

                <b-col cols="12" md="6">
                    <label class="sa-label-data">Codice listino</label>
                    <span>{{ jsonData.codiceListino }}</span>
                </b-col>

                <b-col cols="12" md="3">
                    <label class="sa-label-data">Codice tipo soggetto</label>
                    <span>{{ jsonData.codiceTipoSoggetto }}</span>
                </b-col>

                <b-col cols="12" md="6">
                    <label class="sa-label-data">Descrizione tipo soggetto</label>
                    <span>{{ jsonData.descrizioneTipoSoggetto }}</span>
                </b-col>

                <b-col cols="12" md="3">
                    <label class="sa-label-data">Codice metodo pagamento</label>
                    <span>{{ jsonData.codiceMetodoPagamento }}</span>
                </b-col>

                <b-col cols="12" md="3">
                    <label class="sa-label-data">Descrizione metodo pagamento</label>
                    <span>{{ jsonData.descrizioneMetodoPagamento }}</span>
                </b-col>

                <b-col cols="12" md="3">
                    <label class="sa-label-data">Fido soggetto</label>
                    <span>{{ jsonData.fidoSoggetto }}</span>
                </b-col>

                <b-col cols="12" md="3">
                    <label class="sa-label-data">Sconto soggetto</label>
                    <span>{{ jsonData.scontoSoggetto }}</span>
                </b-col>

                <b-col cols="12" md="3">
                    <label class="sa-label-data">Provvigione soggetto</label>
                    <span>{{ jsonData.provvigioneSoggetto }}</span>
                </b-col>

                <b-col cols="12" md="3">
                    <label class="sa-label-data">Porto soggetto</label>
                    <span>{{ jsonData.portoSoggetto }}</span>
                </b-col>

                <b-col cols="12" md="3">
                    <label class="sa-label-data">Vettore soggetto</label>
                    <span>{{ jsonData.vettoreSoggetto }}</span>
                </b-col>

                <b-col cols="12" md="3">
                    <label class="sa-label-data">Codice soggetto rif</label>
                    <span>{{ jsonData.codiceSoggettoRif }}</span>
                </b-col>

                <b-col cols="12" md="3">
                    <label class="sa-label-data">Tipo identificativo</label>
                    <span>{{ jsonData.tipoIdentificativo }}</span>
                </b-col>
            </b-row>
        </b-card>

        <b-card class="sa-card" header="Note" header-tag="header">
            <b-row>
                <b-col cols="12" md="6">
                    <label class="sa-label-data">Note soggetto</label>
                    <b-form-textarea v-model="jsonData.noteSoggetto" rows="3" readonly />
                </b-col>
                <b-col cols="12" md="6">
                    <label class="sa-label-data">Note documento</label>
                    <b-form-textarea v-model="jsonData.noteDocumento" rows="3" readonly />
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>
<script>
import UtilityMixin from "../../utility/UtilityMixin";
export default {
    mixins: [UtilityMixin],
    data() {
        return {
            jsonData: {
                capDomicilio: null,
                capResidenza: null,
                capSoggetto: null,
                codiceAzienda: null,
                codiceDestinatario: null,
                codiceIva: null,
                codiceListino: null,
                codiceMetodoPagamento: null,
                codiceSoggetto: null,
                codiceSoggettoRif: null,
                codiceTipoSoggetto: null,
                cognome: null,
                comuneDomicilioCodiceIstat: null,
                comuneNascitaCodiceIstat: null,
                comuneResidenzaCodiceIstat: null,
                dataNascita: null,
                descrizioneMetodoPagamento: null,
                descrizioneTipoSoggetto: null,
                email: null,
                fidoSoggetto: null,
                identificativoSoggetto: null,
                indirizzoDomicilio: null,
                indirizzoSoggetto: null,
                localitaSoggetto: null,
                nazioneSoggetto: null,
                nome: null,
                noteDocumento: null,
                noteSoggetto: null,
                pec: null,
                pivaSoggetto: null,
                portoSoggetto: null,
                proprietario: null,
                provinciaSoggetto: null,
                provvigioneSoggetto: null,
                ragioneSoggetto: null,
                scontoSoggetto: null,
                sesso: null,
                telefono: null,
                tipoIdentificativo: null,
                vettoreSoggetto: null,
                provinciaNascita: null,
                regioneNascita: null,
                provinciaResidenza: null,
                regioneResidenza: null,
                provinciaDomicilio: null,
                regioneDomicilio: null,
                regioneSoggetto: null,
            },
            pathResource: "/contabilitasoggetti",
        };
    },
    mounted() {
        let me = this;
        let id = this.$route.params.id;
        me.loadData(id);
    },
    methods: {
        loadData(id) {
            let me = this;
            me.$emit("beforeLoadData");
            UtilityMixin.methods.loadDataResources(me.pathResource + "/" + id, {}, me.loadDataSuccess, me.loadDataError);
        },
        loadDataSuccess(response) {
            let me = this;
            me.jsonData = response.data.data;
            me.$emit("afterLoadData");
        },
        loadDataError(error) {
            error;
            let me = this;
            me.$emit("afterLoadData");
        },
    },
};
</script>
